const fileInfoClientServiceName = "/FileInfoClient";

export function fileInfoClientService (http) {
    return {
        getAllClientCategoriesAsync: async (dateFrom, dateTo, seenRequest) => {
            let params = {
                dateFrom,
                dateTo,
                seenRequest
            }
            return await http.post(fileInfoClientServiceName + '/GetAllInfoBoardClientsAsync', params);
        }
    }
}
